import { DashboardLayout } from '@/components/layout/DashboardLayout';
import OnChainReceipts from '@/components/ledger/OnChainReceipts';
import { useTenantStore } from '@/hooks/useTenantStore';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle } from 'lucide-react';

export default function OnChainReceiptsPage() {
  const { tenantId } = useTenantStore();

  if (!tenantId) {
    return (
      <DashboardLayout>
        <Card>
          <CardContent className="flex items-center justify-center py-8">
            <div className="text-center">
              <AlertCircle className="h-12 w-12 mx-auto mb-4 text-muted-foreground" />
              <p className="text-muted-foreground">Please select a company</p>
            </div>
          </CardContent>
        </Card>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold">On-Chain Receipts</h1>
          <p className="text-muted-foreground mt-1">Blockchain notarization of key ledger events</p>
        </div>
        <OnChainReceipts companyId={tenantId} />
      </div>
    </DashboardLayout>
  );
}
